import { useQuery } from '@tanstack/react-query';
import {
  getReferralUsersListing,
  GetReferralUsersParams,
  getDownlineStats,
} from '@/api/referral';

export function useReferralUsersListing(params?: GetReferralUsersParams) {
  return useQuery({
    queryKey: ['referral-users-list', params],
    queryFn: () => getReferralUsersListing(params),
    placeholderData: (previousData) => previousData,
  });
}

export function useDownlineStats(userId: number | null) {
  return useQuery({
    queryKey: ['downline-stats', userId],
    queryFn: () => getDownlineStats(userId!),
    enabled: userId !== null,
  });
}
